import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trash2, Sprout, ArrowUpRight } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';
import { CROPS, formatEuro, formatQ } from './yieldConstants';
import { HarvestInput } from './HarvestInput';

export default function YieldHistory() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/ai/yield-history').then(r => setItems(r.data || [])).catch(() => setItems([])); }, []);

  const remove = async (id) => {
    try { await api.delete(`/ai/yield-history/${id}`); setItems(x => x.filter(i => i.estimate_id !== id)); toast.success('Stima eliminata'); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  if (items === null) return <div className="text-sm text-muted-foreground">Caricamento…</div>;
  if (!items.length) return (
    <div className="rounded-2xl border border-dashed border-border p-10 text-center" data-testid="yield-history-empty">
      <Sprout size={28} className="mx-auto text-chartreuse mb-3" strokeWidth={1.4}/>
      <div className="font-display text-xl">Nessuna stima salvata</div>
      <p className="text-sm text-muted-foreground mt-1">Ogni stima Yield AI PRO che fai da loggato viene salvata qui.</p>
      <Link to="/stima-quintali" className="mt-4 inline-flex text-sm text-chartreuse hover:underline">Fai la tua prima stima →</Link>
    </div>
  );

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="yield-history-list">
      {items.map(it => {
        const c = CROPS.find(x => x.v === it.input?.crop);
        const I = c?.I || Sprout;
        const size = it.input?.area_hectares ? `${it.input.area_hectares} ha` : `${it.input?.number_of_trees} piante`;
        return (
          <div key={it.estimate_id} className="group rounded-2xl glass-vp p-5 relative transition-transform hover:-translate-y-0.5" data-testid={`yield-history-${it.estimate_id}`}>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-xl bg-chartreuse/10 grid place-items-center"><I size={18} className="text-chartreuse"/></span>
              <div className="min-w-0">
                <div className="font-medium truncate">{c?.l || it.input?.crop}{it.input?.variety ? ` · ${it.input.variety}` : ''}</div>
                <div className="text-xs text-muted-foreground">{size} · {it.result?.regione || 'Italia'} · {new Date(it.created_at).toLocaleDateString('it-IT')}</div>
              </div>
              <button onClick={() => remove(it.estimate_id)} className="ml-auto text-muted-foreground hover:text-destructive transition-colors" aria-label="Elimina" data-testid={`yield-history-delete-${it.estimate_id}`}><Trash2 size={15}/></button>
            </div>
            <div className="mt-4 flex items-end justify-between">
              <div>
                <div className="font-display text-2xl text-chartreuse">{formatQ(it.result?.quintali_stimati)}</div>
                <div className="text-xs text-terracotta">{formatEuro(it.result?.valore_euro_medio)} · confidenza {it.result?.confidenza}</div>
              </div>
              <Link to={`/stima-quintali?stima=${it.estimate_id}`} className="inline-flex items-center gap-1 text-xs text-[#8dd8ff] hover:underline" data-testid={`yield-history-open-${it.estimate_id}`}>
                Apri report <ArrowUpRight size={12}/>
              </Link>
            </div>
            <HarvestInput estimateId={it.estimate_id} actual={it.actual}
              onSaved={a => setItems(x => x.map(i => (i.estimate_id === it.estimate_id ? { ...i, actual: a } : i)))}/>
          </div>
        );
      })}
    </div>
  );
}
